module.exports = __webpack_public_path__ + "static/img/detailOl.8a1cb02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/detailOl.jpg
// module id = hq0W
// module chunks = 7